import { render, staticRenderFns } from "./topNews.vue?vue&type=template&id=fba897be&"
import script from "./topNews.vue?vue&type=script&setup=true&lang=js&"
export * from "./topNews.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./topNews.vue?vue&type=style&index=0&id=fba897be&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports